import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function AccountSignIn() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(API + "/account/otp/request", { email }, { withCredentials: true });
      sessionStorage.setItem("aiude_account_email", email);
      toast.success("Check your email for a sign-in code.");
      nav("/account/verify");
    } catch (err) {
      const status = err?.response?.status;
      if (status === 503) toast.error(err?.response?.data?.detail || "Sign-in is temporarily unavailable. Please try again later.");
      else if (status === 429) toast.error("Too many attempts. Please try again later.");
      else toast.error(err?.response?.data?.detail || "Sign-in failed. Please try again.");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="max-w-lg mx-auto py-10 lg:py-16" data-testid="account-signin-page">
      <div className="font-tech text-xs text-slate-400 mb-2">CONTROL CENTER</div>
      <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3">Sign in to your Control Center</h1>
      <p className="text-slate-400 text-sm mb-6">Enter your registered email. We'll send a six-digit code — no password required.</p>
      <form onSubmit={submit} className="panel-elev p-6 space-y-4" data-testid="account-signin-form">
        <div>
          <div className="text-xs font-tech text-slate-400 uppercase tracking-wider mb-1">Email</div>
          <input type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-slate-900 border border-slate-700 rounded px-3 py-2 text-white"
            data-testid="account-signin-email" />
        </div>
        <button type="submit" disabled={submitting || !email}
          className="w-full py-2.5 bg-[#00D2FF] text-slate-900 font-semibold rounded disabled:opacity-50"
          data-testid="account-signin-submit">
          {submitting ? "Sending…" : "Send me a sign-in code"}
        </button>
      </form>
    </div>
  );
}
